import * as React from "react";
import ListLoader from "../../../utils/loader/ListLoader";
import {IIsVisible} from "../../Checkout";
import KnownCustomer from "./KnownCustomer/KnownCustomer";
import GuestCustomer from "./GuestCustomer";
import RegisterCustomer from "./RegisterCustomer";
import OurStandards from "./OurStandards";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";

const Login: React.FC<IIsVisible> = (props) => {
  const {checkout} = useCheckoutContext();

  if (!props.isVisible) {
    return null;
  }

  const onLoggedIn = () => {
    if (checkout.isGuest) {
      void checkout.put({isGuest: false});
    }
  };

  return (
    <div className={"text checkout-content"}>
      <React.Suspense fallback={<ListLoader />}>
        <div className="account-login login-block" style={{marginBottom: "0"}}>
          <KnownCustomer onLoggedIn={onLoggedIn} />
        </div>
        <div className="account-login" id="CheckoutRegistration">
          <RegisterCustomer />
        </div>
        <br className="clear" />
        <GuestCustomer />
        <OurStandards />
      </React.Suspense>
    </div>
  );
};

export default Login;
